import { Controller } from "@hotwired/stimulus"

// Simple show/hide toggle. Used by the mobile nav hamburger and the account menu.
export default class extends Controller {
  static targets = ["panel", "button"]

  connect() {
    this.onKeydown = (e) => { if (e.key === "Escape" && this.open) this.close({ restoreFocus: true }) }
    this.onClick = (e) => { if (this.open && !this.element.contains(e.target)) this.close() }
    document.addEventListener("keydown", this.onKeydown)
    document.addEventListener("click", this.onClick)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    document.removeEventListener("click", this.onClick)
  }

  get open() {
    return this.hasPanelTarget && !this.panelTarget.hidden
  }

  toggle(e) {
    e?.preventDefault?.()
    this.open ? this.close() : this.show()
  }

  show() {
    this.panelTarget.hidden = false
    this.sync()
  }

  close({ restoreFocus = false } = {}) {
    if (!this.hasPanelTarget) return
    this.panelTarget.hidden = true
    this.sync()
    if (restoreFocus && this.hasButtonTarget) this.buttonTarget.focus()
  }

  sync() {
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", String(this.open))
  }
}
